import { Progress } from "@gravity-ui/uikit";
import { AtomMut } from "@reatom/framework";
import { useAtom } from "@reatom/npm-react";

export const ProgressBar = ({
  progressAtom,
}: {
  progressAtom: AtomMut<number>;
}) => {
  const [progress] = useAtom(progressAtom);
  return (
    <div style={{ width: "100%" }}>
      <Progress theme="warning" value={progress} size="xs" />
    </div>
  );
};
